<div class="ws-flex-container-vertical ws-flex-auto h-100 mh-100">
    <div class="ws-section">
        <div class="ws-section__header">
            <h4 class="ws-section__header__title page-title">
                Cap Rules
            </h4>
            <div class="ws-section__header__actions">
                <div class="ws-section__header__actions__item">
                    <show-tax-year [(taxYearBegin)]="taxYearBegin" [(taxYearsPrior)]="taxYearsPrior" (showTaxYearChanged)="showTaxYearChanged()"></show-tax-year>
                </div>
                @if (canEditRoles) {
                    <div class="ws-section__header__actions__item">
                        <button type="button"
                                class="ace-btn btn-primary btn-sm"
                                (click)="addCapRule()"
                                helpTooltip
                                helpContentId="asset-list.new-asset"
                                position="bottom"
                                [disabled]="refreshing">
                            New Cap Rule
                        </button>
                    </div>
                }
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary has-icon"
                            (click)="refresh()"
                            [disabled]="refreshing">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <ws-ag-grid-angular
        [gridId]="gridId"
        [gridOptions]="gridOptions"
        (gridReady)="onAgGridReady($event)">
    </ws-ag-grid-angular>
</div>
